/**
 * SleepKarma custom buy box for /products/nose-tape.
 * Pairs with snippets/sk-buybox-nose-tape.liquid.
 *
 * Nose tape has a single option axis (Supply: 1/3/6 Month). Each variant
 * carries its own selling plan allocation. Quantity is always 1 because
 * the variant itself encodes the supply length.
 *
 * - Maps Supply selection to variant + matching Skio selling plan
 * - Recomputes the total/compare price displayed in the Start Now button
 * - Handles the "One time purchase" fallback (clears selling_plan, keeps variant)
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-sk-buybox-nt]').forEach(setup);
  }

  function setup(root) {
    const productScript = root.querySelector('[data-sk-product]');
    if (!productScript) return;

    let product;
    try {
      product = JSON.parse(productScript.textContent);
    } catch (e) {
      return;
    }

    const variantInput = root.querySelector('[data-sk-variant-input]');
    const planInput = root.querySelector('[data-sk-plan-input]');
    const submitPriceEl = root.querySelector('[data-sk-submit-price]');
    const submitCompareEl = root.querySelector('[data-sk-submit-compare]');
    const onetimePriceEl = root.querySelector('[data-sk-onetime-price]');
    const submitBtn = root.querySelector('button[type="submit"][name="add"]');

    // Each Skio selling plan is bound to one specific variant — submitting
    // a non-matching plan→variant combo errors with "Cannot apply selling
    // plan to variant". So the cart payload uses the radio's matching
    // variant id (qty=1), not a constant id. Discount + delivery cadence
    // ride on the matched plan.
    const variantAvailableById = {};
    product.variants.forEach(function (v) { variantAvailableById[v.id] = v.available; });

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function update() {
      const supplyEl = root.querySelector('[data-sk-supply]:checked');
      if (!supplyEl) return;

      const variantId = parseInt(supplyEl.dataset.skVariantId || '0', 10);
      const planId = supplyEl.dataset.skPlanId || '';
      const subCents = parseInt(supplyEl.dataset.skSubCents || '0', 10);
      const compareCents = parseInt(supplyEl.dataset.skCompareCents || '0', 10);
      const available = variantAvailableById[variantId] !== false;

      if (variantInput) variantInput.value = variantId;
      if (planInput) planInput.value = planId;

      if (submitPriceEl) submitPriceEl.textContent = money(subCents);
      if (submitCompareEl) submitCompareEl.textContent = money(compareCents);
      if (onetimePriceEl) onetimePriceEl.textContent = money(compareCents);

      root.querySelectorAll('.frequency-option').forEach(function (wrap) {
        const input = wrap.querySelector('[data-sk-supply]');
        wrap.classList.toggle('selected', !!(input && input.checked));
      });

      if (submitBtn) submitBtn.disabled = !available;
    }

    root.querySelectorAll('[data-sk-supply]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    const onetimeBtn = root.querySelector('[data-sk-onetime]');
    if (onetimeBtn) {
      onetimeBtn.addEventListener('click', function () {
        const supplyEl = root.querySelector('[data-sk-supply]:checked');
        if (!supplyEl) return;
        const variantId = parseInt(supplyEl.dataset.skVariantId || '0', 10);
        if (variantInput) variantInput.value = variantId;
        if (planInput) planInput.value = '';
        // Click the real submit button so Wonder's <product-form> intercepts
        // the submit (AJAX add → cart drawer) instead of redirecting to /cart.
        if (submitBtn) submitBtn.click();
        update();
      });
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
